<template>
  <v-row
    class="px-0"
    no-gutters
  >
    <v-col cols="12">
      <v-checkbox
        v-model="checkbox"
        :label="label"
        @change="valueChanged"
      ></v-checkbox>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "Checkbox",
  components: {},
  props: {
    name: {type: String, default: ''},
    value: { type: Boolean, default: false },
    label: {}
  },
  data() {
    return {
      checkbox: false
    };
  },
  methods: {
    valueChanged() {
      this.$emit('input', this.checkbox)
    }
  },
  watch: {},
  mounted() {
    this.checkbox = this.value;
  },
};
</script>
